import { ModalControlsLoadableFactory } from '®shared/modals';

import {
  ReviewHistoryActionTypes,
  ReviewHistoryActions,
} from './review-history.actions';
import {
  REVIEW_HISTORY_INITIAL_STATE,
  ReviewHistoryState,
} from './review-history.state';

export function reviewHistoryReducer(
  state: ReviewHistoryState = REVIEW_HISTORY_INITIAL_STATE,
  action: ReviewHistoryActions,
): ReviewHistoryState {
  switch (action.type) {
    case ReviewHistoryActionTypes.REVIEW_HISTORY_SHOW_MODAL: {
      const { listId } = action.payload;
      return {
        listId,
        modalControls: ModalControlsLoadableFactory.show(),
      };
    }

    case ReviewHistoryActionTypes.REVIEW_HISTORY_HIDE_MODAL: {
      return {
        listId: null,
        modalControls: ModalControlsLoadableFactory.hide(),
      };
    }

    case ReviewHistoryActionTypes.REVIEW_HISTORY_REQUESTED: {
      const { listId } = action.payload;
      return {
        listId,
        modalControls: ModalControlsLoadableFactory.loading(),
      };
    }

    case ReviewHistoryActionTypes.REVIEW_HISTORY_LOADED: {
      const { listId, reviews } = action.payload;
      return {
        listId,
        modalControls: ModalControlsLoadableFactory.loaded(reviews),
      };
    }

    case ReviewHistoryActionTypes.REVIEW_HISTORY_LOADING_FAILED: {
      const { listId, error } = action.payload;
      return {
        listId,
        modalControls: ModalControlsLoadableFactory.errorLoading(error),
      };
    }

    default: {
      return state;
    }
  }
}
